// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__3qqMK","header":"PatientQuestionnaire_header__1Ui0Q","info":"PatientQuestionnaire_info__3UDX8"};